/**
 * 공개 status 페이지 오리진 — 앱 footer는 환경과 무관하게 **항상 production**을 가리킨다.
 * `status-staging.schoolbell-e.com`(staging 관측 데이터 전용 뷰, `sbe-status-web`이 같은
 * API를 `?env=staging`으로 부르는 별도 사이트)이 존재하지만, footer는 최종 사용자용
 * 링크라 staging 앱에서도 production 실서비스 상태를 보여주는 편이 옳다.
 */
export const STATUS_WEB_ORIGIN = 'https://status.schoolbell-e.com';

/** `apps/sbe-status/web` 의 앱 상세 라우트(`/apps/:app`)와 형태를 맞춘다. */
export function buildStatusAppUrl(slug: string): string {
  return `${STATUS_WEB_ORIGIN}/apps/${encodeURIComponent(slug)}`;
}
